const VARIANT_CLS = { bull: 'pc-bull', base: 'pc-base', bear: 'pc-bear' };

export default function ProbabilityGrid({ scenarios = [], onSelectStock }) {
  return (
    <div className="prob-grid">
      {scenarios.map((s, i) => (
        <div key={i} className={`prob-card ${VARIANT_CLS[s.variant] ?? ''}`}>
          <div className="prob-label">{s.label}</div>
          <div className="prob-pct">{s.pct}%</div>
          <div className="prob-desc">{s.desc}</div>
          {s.chips?.length > 0 && (
            <div className="prob-chips">
              {s.chips.map(sym => (
                <span
                  key={sym}
                  className="prob-chip"
                  onClick={() => onSelectStock?.(sym)}
                >
                  {sym}
                </span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
